export const desiredTargetFilterStyles = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
  flexShrink: 0,
};
